import { ReactNode } from 'react';
import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    borderTop: 0,
    borderRight: 0,
    backgroundColor: theme.palette.white,
    paddingInline: theme.spacing(1.5),
    height: '32px',
    borderRadius: 0,
    boxShadow: `0px 4px 16px 0px ${theme.palette.grey[200]}`,
  },
}));

export type WbHeaderActionButtonProps = Omit<IconButtonProps, 'children'> & {
  icon: ReactNode;
};

export const WbHeaderActionButton = ({
  icon,
  className,
  ...props
}: WbHeaderActionButtonProps) => {
  const classes = useStyles();
  return (
    <IconButton
      size="small"
      className={`${classes.iconWrapper}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {icon}
    </IconButton>
  );
};
